import { createContext, ReactNode, useContext } from "react"

const environmentContext = createContext<any>(null)

export interface ProviderUtils {
    isClient: boolean,
    [key: string]: any
}

export const useEnvironment: () => ProviderUtils = () => {
    return useContext(environmentContext)
}

export function EnvironmentProvider({ children, env: newEnv = undefined }: { children: ReactNode | string, env?: ProviderUtils }) {

    let env: ProviderUtils = {
        isClient: false,
        ...newEnv
    }

    try {
        const host = (window as any)['location']['host']
        env = {
            isClient: true,
            ...(window as any)['__env'],
            development: String(host).includes('127.0.0.1') || String(host).includes('localhost')
        }
    } catch (error) {
    }

    return (
        <environmentContext.Provider value={env}>
            {children}
        </environmentContext.Provider>
    )
}